import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
} from "@mui/material";
import { getData, getDataIx0 } from "../../../services/library";

export default function ModalInfoCliente(props) {
  const [infoFact, setinfoFact] = useState();
  const [infoClienteAnterior, setinfoClienteAnterior] = useState();
  const [infoDirec, setinfoDirec] = useState();
  const [infoTanques, setinfoTanques] = useState();

  useEffect(() => {
    if (props.dataCliente.nro_cliente) {
      getDataIx0(
        `/factibilidades/xcliente/${props.dataCliente.nro_cliente}/${props.dataCliente.id_cliente}`,
        setinfoFact
      );
    } else if (props.dataCliente.id_titular_anterior) {
      getDataIx0(
        `/clientes/${props.dataCliente.id_titular_anterior}`,
        setinfoClienteAnterior
      );
    }

    getDataIx0(
      `/direccionesentrega/${props.dataCliente.id_direccionentrega}`,
      setinfoDirec
    );
    getData(
      `/tanques/dirent/${props.dataCliente.id_direccionentrega}`,
      setinfoTanques
    );
  }, [props.dataCliente]);

  // console.log("infofact",infoFact);
  // console.log("infoclienteanterior", infoClienteAnterior);
  // console.log("infodirec", infoDirec);
  // console.log("infotanques", infoTanques);

  return (
    <div>
      <Dialog open={props.open} onClose={() => props.setopen(false)} fullWidth>
        <Box backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h5" align="center" color="#ffffff">
              Información cliente {props.dataCliente.cliente}
            </Typography>
          </DialogTitle>
        </Box>

        <DialogContent sx={{ padding: 3 }}>
          {/* Sección: Domicilio de instalación */}
          <Box mb={2}>
            <Typography variant="h6" gutterBottom>
              Domicilio de instalación
            </Typography>
            <Typography variant="body1">
              {infoDirec?.nombre_direccion} {infoDirec?.direccion_entrega}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Sección: Tanques */}
          <Box mb={2}>
            <Typography variant="h6" gutterBottom>
              Tanques
            </Typography>
            {infoTanques && infoTanques.length > 0 ? (
              infoTanques.map((tanque, index) => (
                <Box key={index} sx={{ display: "flex", gap: 2, mb: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Nro serie:</strong> {tanque.nro_serie}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Capacidad:</strong> {tanque.capacidad}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography variant="body2" color="text.secondary">
                No hay tanques disponibles.
              </Typography>
            )}
          </Box>

          <Divider sx={{ my: 2 }} />

          {/* Sección: Factibilidad */}
          {infoFact && (
            <Box mb={2}>
              <Typography variant="h6" gutterBottom>
                Factibilidad
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Tipo:</strong> {infoFact.tipo_factibilidad}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>Costos:</strong> {infoFact.motivocli1} : $
                {infoFact.cantmotivocli1} sin impuestos
              </Typography>
            </Box>
          )}

          {/* Sección: Cliente anterior */}
          {infoClienteAnterior && (
            <>
              <Divider sx={{ my: 2 }} />
              <Box>
                <Typography variant="h6" gutterBottom>
                  Cliente anterior
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {infoClienteAnterior.razon_social}
                </Typography>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

{
  /*MODAL PARA VER LA INFORMACION DEL CLIENTE
    -- SI EL CLIENTE TIENE UUID (NRO_CLIENTE) QUIERE DECIR QUE TIENE FACTIBILIDAD 235 (NUEVO CLIENTE)
    -- SI NO TIENE PUEDE SER QUE TENGA FACTIBILIDAD PARA AMPLIACION TANTO EN DOM NUEVO COMO EN DOM EXISTENTE.
    PRIMERO ME FIJO ESO
*/
}
